import React from 'react'
import { Helmet } from 'react-helmet'
import MyStory from './MyStory'
import Timeline from './Timeline'
import StoryVideo from './StoryVideo'
const StoryMain = () => {
    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <meta name='description' content='Discover the journey of Umang Ratani, where passion meets expertise. Learn how our business consultancy transforms visions into reality, one success story at a time.' />
                <title>Umang Ratani: Elevating Businesses with Expert Consultancy</title>
            </Helmet>
            <MyStory />
            <Timeline />
            <StoryVideo />
        </>
    )
}

export default StoryMain
